<div class="cerrarModalOtp">
    <i class="fa-regular fa-circle-xmark close-button" (click)="closeModal()"></i>
</div>
<div class="verifyNumber">
    <img class="exclamation-triangle" src="\assets\img\comparative\exclamation-triangle.svg" alt="exclamation">
    <p>Es necesario verificar tu número de contacto</p>
    <button class="btnOtp" (click)="openOtpValidation()">Verificar</button>
</div>
